<template>
  <div class="product-installments-props">
    <div v-if="result.price && result.price.printPsPrice" class="product-installments-props__row">
      <p class="product-installments-props__name">
        <!--                Сумма:-->
        {{ messages?.totalPrice }}:
      </p>

      <p class="product-installments-props__value">{{ result.price.printPsPrice }}</p>
    </div>
    <div
      v-if="result.price && result.price.printPsMonthlyPrice"
      class="product-installments-props__row"
    >
      <p class="product-installments-props__name">
        <!--                Первый платеж:-->
        {{ messages?.firstPay }}:
      </p>
      <p class="product-installments-props__value">{{ result.price.printPsMonthlyPrice }}</p>
    </div>
    <div v-if="result.PARTS_COUNT" class="product-installments-props__row">
      <p class="product-installments-props__name">
        <!--                Количество платежей:-->
        {{ messages?.numberOfPayments }}:
      </p>
      <p class="product-installments-props__value">{{ result.PARTS_COUNT }}</p>
    </div>
    <div
      v-if="result.price && result.price.printPsMonthlyPrice"
      class="product-installments-props__row"
    >
      <p class="product-installments-props__name">
        <!--                Ежемесячный платеж:-->
        {{ messages?.monthlyPay }}:
      </p>
      <p class="product-installments-props__value">{{ result.price.printPsMonthlyPrice }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductInstallmentsProps',
  props: ['result'],
  computed: {
    ...mapState({
      messages: ({ product }) => product?.data?.messages,
    }),
  },
  mounted() {
    // console.log(this.messages);
  },
};
</script>

<style lang="scss" scoped>
.product-installments-props {
  display: grid;
  grid-row-gap: 12px;
  font-weight: 500;
  font-size: 16px;
  color: var(--color-dark-grey);
  &__row {
    display: flex;
    justify-content: space-between;
  }
  &__name {
    line-height: 100%;
  }
  &__value {
    color: var(--color-main);
    line-height: 100%;
  }
}
</style>
